import { FC } from "react";
import { Paper, Box, useTheme } from "@mui/material";
import __ from "src/utils/Translations";
import AreaAutocomplete from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Components/Autocomplete/AreaAutocomplete";
import OrgchartSelect from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/Shared/OrgchartSelect";

interface IAreasFilterBar {
  companyId: string;
}

const FilterBar: FC<IAreasFilterBar> = ({ companyId }) => {
  const theme = useTheme();

  return (
    <Paper sx={{ p: 2 }} data-testid="os__view-filter-bar">
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          flexDirection: "column",
          gap: "16px",
          justifyContent: "flex-start",
          [theme.breakpoints.up("md")]: {
            flexDirection: "row",
            alignItems: "center",
          },
        }}
      >
        <OrgchartSelect companyId={companyId} />
        <AreaAutocomplete
          name="autocomplete"
          label={__("Szukaj")}
          onSubmit={() => {}}
        />
      </Box>
    </Paper>
  );
};

export default FilterBar;
